import { PAY_PERIOD_PROFILES } from "../types";
const PayPeriodProfiles = (state = [], action) => {
    if (action.type === PAY_PERIOD_PROFILES) {
        state = action.payload;
    };
    return state;
};

export default PayPeriodProfiles;